import type { JSX } from "react";
import { FluentButton } from "@/components/fluent-ui";
import { useAuth } from "@/services/auth/use-auth";
import "./Profile.scss";

function initialsFromName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function Profile(): JSX.Element {
  const { user, logout } = useAuth();
  const displayName = user?.Name || user?.UserName || "Signed in";
  const email = user?.Email || user?.UserName || "";
  const initials = initialsFromName(displayName);

  return (
    <div className="profile">
      <span className="profile__avatar" aria-hidden>
        {initials}
      </span>
      <div className="profile__name">{displayName}</div>
      {email ? <div className="profile__email">{email}</div> : null}
      <div className="profile__meta">Connected via TRIYO API</div>
      <FluentButton text="Sign out" appearance="secondary" className="profile__logout" onClick={logout} />
    </div>
  );
}
